import SkeletonLoader from "shrimmer/SkeletonLoader";

const InvoiceShrimmer = () => {
  return (
    <tbody>
      {Array.from({ length: 6 }, (_, index) => (
        <tr key={index}>
          <td className="text-center">
            <SkeletonLoader type="text" height={20} width={45} />
          </td>
          <td>
            <SkeletonLoader type="text" height={20} width={80} />
          </td>
          <td>
            <SkeletonLoader type="text" height={20} width={250} />
          </td>
          <td>
            <SkeletonLoader type="text" height={20} width={150} />
          </td>
          <td className="text-center">
            <SkeletonLoader type="text" height={20} width={60} />
          </td>
          <td className="text-center">
            <SkeletonLoader type="text" height={20} width={80} />
          </td>
          <td className="text-center">
            <button type="button" className="action_button">
              <SkeletonLoader type="text" height={20} width={20} />
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default InvoiceShrimmer;
